import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import axiosInstance from '../../services/axiosInstance';

function CHRPage() {
  const [open, setOpen] = useState(false);
  const [establishments, setEstablishments] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const fetchEstablishments = async () => {
      const partnerUserId = localStorage.getItem('user_id');
      try {
        const response = await axiosInstance.get(`/partner_users/${partnerUserId}/get_establishments`);
        setEstablishments(response.data.establishment);
      } catch (error) {
        console.error('Erreur lors de la récupération des établissements', error);
      }
    };

    fetchEstablishments();
  }, []);

  const handleAddEstablishment = async (newEstablishment) => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        console.log(`Bearer ${token}`);
        console.log('https://backoffice.gourdefriendly.green/partner_users/add_establishment');
        console.log(newEstablishment);
      }

      const response = await axiosInstance.post('/partner_users/add_establishment', newEstablishment);
      setEstablishments([...establishments, response.data.establishment]);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout d\'un établissement', error);
      return null;
    }
  };

  const styles = {
    container: {
      backgroundColor: '#f8fafc',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },
    header: {
      backgroundColor: '#ffffff',
      padding: '32px',
      borderBottom: '1px solid #e2e8f0',
      marginBottom: '32px'
    },
    headerContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    title: {
      fontSize: '32px',
      fontWeight: '700',
      color: '#1e293b',
      margin: 0
    },
    subtitle: {
      fontSize: '16px',
      color: '#64748b',
      margin: '8px 0 0 0'
    },
    addButton: {
      backgroundColor: '#059669',
      color: '#ffffff',
      border: 'none',
      borderRadius: '12px',
      padding: '16px 24px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'all 0.2s ease-in-out',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    },
    content: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 32px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
      gap: '24px',
      marginTop: '32px'
    },
    card: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      padding: '24px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      border: '1px solid #e2e8f0',
      transition: 'all 0.2s ease-in-out',
      cursor: 'pointer'
    },
    cardHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
    },
    establishmentName: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#1e293b',
      marginBottom: '16px'
    },
    manageButton: {
      backgroundColor: '#f1f5f9',
      color: '#475569',
      border: 'none',
      borderRadius: '8px',
      padding: '12px 20px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      textDecoration: 'none',
      display: 'inline-block'
    },
    emptyState: {
      textAlign: 'center',
      padding: '80px 32px',
      color: '#64748b'
    },
    emptyIcon: {
      fontSize: '64px',
      marginBottom: '16px'
    },
    emptyTitle: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '8px'
    },
    emptyDescription: {
      fontSize: '16px',
      color: '#6b7280',
      marginBottom: '24px'
    }
  };

  return (
    <div style={styles.container}>
      <Navbar />
      
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div>
            <h1 style={styles.title}>Mes Établissements</h1>
            <p style={styles.subtitle}>
              Gérez vos établissements et leurs informations
            </p>
          </div>
          <button
            onClick={handleOpen}
            style={styles.addButton}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <span style={{ fontSize: '20px' }}>+</span>
            Ajouter un établissement
          </button>
        </div>
      </div>

      <div style={styles.content}>
        {establishments.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={styles.emptyIcon}>🏪</div>
            <h3 style={styles.emptyTitle}>Aucun établissement trouvé</h3>
            <p style={styles.emptyDescription}>
              Commencez par ajouter votre premier établissement pour commencer à gérer vos activités.
            </p>
            <button
              onClick={handleOpen}
              style={{
                ...styles.addButton,
                margin: '0 auto'
              }}
            >
              <span style={{ fontSize: '20px' }}>+</span>
              Ajouter mon premier établissement
            </button>
          </div>
        ) : (
          <div style={styles.grid}>
            {establishments.map((establishment, index) => (
              <div
                key={index}
                style={styles.card}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, styles.cardHover);
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)';
                }}
              >
                <h3 style={styles.establishmentName}>
                  {establishment.name}
                </h3>
                <Link
                  to={`/admin/${establishment.id}`}
                  style={styles.manageButton}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#e2e8f0';
                    e.target.style.color = '#334155';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#f1f5f9';
                    e.target.style.color = '#475569';
                  }}
                >
                  Gérer l'établissement →
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>

      <EstablishmentModal 
        open={open} 
        onClose={handleClose} 
        onAdd={handleAddEstablishment} 
      />
    </div>
  );
}

function EstablishmentModal({ open, onClose, onAdd }) {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const getCoordinates = async (address) => {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${address}`;
    const response = await axios.get(url);
    if (response.data && response.data[0]) {
      return {
        lat: parseFloat(response.data[0].lat),
        lon: parseFloat(response.data[0].lon)
      };
    }
    return null;
  };

  const handleAdd = async () => {
    if (!name || !address || !email || !phone) {
      alert('Veuillez remplir tous les champs obligatoires.');
      return;
    }

    setIsLoading(true);
    
    try {
      const coordinates = await getCoordinates(address);
      if (!coordinates) {
        alert("Impossible d'obtenir les coordonnées pour cette adresse.");
        setIsLoading(false);
        return;
      }

      const newEstablishment = {
        partner_user_id: localStorage.getItem('user_id'),
        name,
        address,
        lat: coordinates.lat,
        lon: coordinates.lon,
        email,
        phone,
      };

      const response = await onAdd(newEstablishment);
      setName('');
      setAddress('');
      setEmail('');
      setPhone('');
      onClose();

      if (response && response.account_link) {
        window.location.href = response.account_link;
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout:', error);
      alert('Une erreur est survenue lors de l\'ajout de l\'établissement.');
    } finally {
      setIsLoading(false);
    }
  };

  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: open ? 'flex' : 'none',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    modal: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      padding: '32px',
      width: '100%',
      maxWidth: '500px',
      maxHeight: '90vh',
      overflow: 'auto',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
    },
    title: {
      fontSize: '24px',
      fontWeight: '700',
      color: '#1e293b',
      marginBottom: '24px',
      textAlign: 'center'
    },
    inputGroup: {
      marginBottom: '20px'
    },
    label: {
      display: 'block',
      fontSize: '14px',
      fontWeight: '500',
      color: '#374151',
      marginBottom: '8px'
    },
    input: {
      width: '100%',
      padding: '12px 16px',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      fontSize: '16px',
      transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
      outline: 'none',
      backgroundColor: '#ffffff',
      boxSizing: 'border-box'
    },
    buttonGroup: {
      display: 'flex',
      gap: '12px',
      marginTop: '32px'
    },
    button: {
      flex: 1,
      padding: '12px 24px',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out'
    },
    primaryButton: {
      backgroundColor: '#059669',
      color: '#ffffff'
    },
    secondaryButton: {
      backgroundColor: '#f1f5f9',
      color: '#475569'
    }
  };

  if (!open) return null;

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={modalStyles.title}>Ajouter un nouvel établissement</h2>
        
        <div style={modalStyles.inputGroup}>
          <label style={modalStyles.label}>Nom de l'établissement *</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={modalStyles.input}
            placeholder="Restaurant Le Bon Goût"
            onFocus={(e) => {
              e.target.style.borderColor = '#059669';
              e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={modalStyles.inputGroup}>
          <label style={modalStyles.label}>Ville *</label>
          <input
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            style={modalStyles.input}
            placeholder="Paris, France"
            onFocus={(e) => {
              e.target.style.borderColor = '#059669';
              e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={modalStyles.inputGroup}>
          <label style={modalStyles.label}>Email *</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={modalStyles.input}
            placeholder="contact@restaurant.com"
            onFocus={(e) => {
              e.target.style.borderColor = '#059669';
              e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={modalStyles.inputGroup}>
          <label style={modalStyles.label}>Téléphone *</label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={modalStyles.input}
            placeholder="01 23 45 67 89"
            onFocus={(e) => {
              e.target.style.borderColor = '#059669';
              e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={modalStyles.buttonGroup}>
          <button
            type="button"
            onClick={onClose}
            style={{
              ...modalStyles.button,
              ...modalStyles.secondaryButton
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e2e8f0';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f1f5f9';
            }}
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={handleAdd}
            disabled={isLoading}
            style={{
              ...modalStyles.button,
              ...modalStyles.primaryButton,
              backgroundColor: isLoading ? '#9ca3af' : '#059669',
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#047857';
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#059669';
              }
            }}
          >
            {isLoading ? 'Ajout en cours...' : 'Ajouter l\'établissement'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CHRPage;